import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { AuthenticationService } from '../../services/authentication.service';
import { TidService } from '../../services/tid.service';

@Component({
  selector: 'app-tid-redirect',
  templateUrl: './tid-redirect.component.html',
})
export class TidRedirectComponent implements OnInit, OnDestroy {
  redirectUrl: string;
  private sm = new SubscriptionManager();
  constructor(
    private tidService: TidService,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    if (location.href.includes('identity_provider=trimble_automation')) {
      const user = JSON.parse(localStorage.getItem('currentUser'));
      this.tidService.loginSuccess(user, user.authToken);
    } else {
      const userExists = JSON.parse(localStorage.getItem('userExists'));
      if (userExists) {
        this.sm.manage = this.tidService
          .loginWithTid()
          .subscribe(([data, token]) => {
            this.tidService.loginSuccess(data.user, token);
          });
      } else {
        this.router.navigateByUrl(
          decodeURIComponent(this.tidService.parentUrl)
        );
      }
    }
  }
  ngOnDestroy(): void {
    this.sm.unsubscribe();
  }
}
